import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  return (
    <section className="py-14 md:py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              最新资讯
            </h2>
            <p className="text-sm text-foreground-600">热门影视动态与视频行业资讯</p>
          </div>
          <Link
            to="/category/shipinzixun"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
          >
            更多文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articles.slice(0, 6).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700">
                    {article.category}
                  </span>
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {(article.views / 1000).toFixed(1)}k
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/shipinzixun"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap"
          >
            更多文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}